export default "__VITE_ASSET__xlFsfIWC__"